/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable */
// @ts-nocheck
import React from 'react';
import Sketch from 'react-p5';
import p5Types from 'p5'; //Import this for typechecking and intellisense

type ComponentProps = {
  tileImage: any;
  groutColor: string;
};

const tileNumberX = 2;
const tileNumberY = 2;

let img;

const RenderGroutColors = ({ tileImage, groutColor, shape }: ComponentProps) => {
  const tileWidth = shape == 'Square' ? 300 : 600;
  const tileHeight = 300;

  const preload = (p5: p5Types) => {
    img = p5.loadImage(tileImage);
  };

  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.pixelDensity(1);
    p5.createCanvas(200, 400, 'webgl').parent(canvasParentRef);
  };

  const draw = (p5: p5Types) => {
    p5.translate(-25, 0);

    for (let y = 0; y < tileNumberX; y++) {
      for (let x = 0; x < tileNumberY; x++) {
        p5.image(img, -x * tileWidth, -y * tileHeight, tileWidth, tileHeight);
        p5.noFill();
        p5.noStroke();
        p5.stroke(groutColor);
        p5.strokeWeight(7);
        p5.rect(-x * tileWidth, -y * tileHeight, tileWidth, tileHeight);
      }
    }
  };

  return (
    <Sketch style={{ width: '100%', height: '100%' }} preload={preload} setup={setup} draw={draw} />
  );
};

export default RenderGroutColors;
